export enum TicketType {
    SOLO = "solo",
    AKO = "ako",
    KOMBI = "kombi",
}

export interface KombiGroupMapping {
    [key: number]: string[];
}

export interface SimplifiedOutcome {
    id: string;
    marketId: string;
    eventId: string;
}

export type WarningFlagTarget = "event" | "outcome" | "ticket" | "leg" | "bet";
export type WarningFlagType =
    | "length"
    | "missingIds"
    | "noMarkets"
    | "suspended"
    | "nonCombinableLegGroups"
    | keyof typeof errorDictionary;
export interface WarningFlag {
    target: WarningFlagTarget;
    type: WarningFlagType;
    info?: Array<string | string[]>;
    text?: string;
}

// MAX_KOMBIGROUP_NUMBER changed to 10... groups K and L will be unused and are kept here because of backward compatibility only
export enum KombiGroup {
    T,
    A,
    B,
    C,
    D,
    E,
    F,
    G,
    H,
    I,
    J,
    K,
    L,
}

export enum PriceChangeBehaviour {
    /** Nepřijímat změny kurzů **/
    NONE = "NONE",
    /** Přijímat vyšší kurz **/
    HIGHER = "HIGHER",
    /** Přijímat všechny změny kurzů **/
    ALL = "ALL",
}

export const errorDictionary = {
    TOO_MANY_OUTCOMES: "Byl překročen maximální povolený počet příležitostí.",
    TRANSACTION_TOTAL_TOO_LOW: "Minimální vklad na sázku je 10 Kč.",
    TRANSACTION_WIN_TOTAL_TOO_HIGH: "Výše maximální výhry přesáhla maximální povolený limit.",
    CUM_DAILY_PAYOUT_EXCEEDED: "Vaše sázka přesahuje maximální povolený denní limit výhry.",
    BET_PRICE_CHANGED: "Tiket nebyl vsazen. Kurzy se změnily.",
    BET_PRICE_CHANGED_MINI_TICKET: "Kurz se změnil.",
    STAKE_TOO_HIGH: "Překročili jste maximální výši sázky.",
    OUTCOME_SUSPENDED: "Před vsazením prosím odstraňte z tiketu pozastavené příležitosti.",
    OFFER_TIMED_OUT: "Platnost nabídky vypršela.",
    POTENTIAL_PAYOUT_TOO_HIGH: "Výše maximální výhry přesáhla povolený limit.",
    INSUFFICIENT_FUNDS: "Nedostatek finančních prostředků na účtu.",
    COOL_OFF_LIMIT: "Pauza po odhlášení: Překročili jste svůj limit zodpovědného hraní.",
    ACCOUNT_IRRESPONSIBLE_GAMING: "Překročili jste svůj limit zodpovědného hraní: Výše sázek za dané období.",
    ACCOUNT_EXCEEDED_DAY_LOSS_LIMIT: "Překročili jste svůj limit zodpovědného hraní: Čistá prohra za den.",
    ACCOUNT_EXCEEDED_MONTH_LOSS_LIMIT: "Překročili jste svůj limit zodpovědného hraní: Čistá prohra za měsíc.",
    ACCOUNT_NOT_ACTIVE: "Váš uživatelský účet není již aktivní.",
    USER_TICKET_CHANGE_DURING_SENDING: "Při odesílání není možné měnit obsah tiketu. Prosím, vyčkejte.",
    TRANSACTION_KOMBI_TOO_LOW: "Musíte vsadit minimálně 0,01 Kč na skupinu.",
    EVENT_STARTED: "Před vsazením prosím odstraňte z tiketu pozastavené příležitosti.",
    RESP_GAMB_LIMIT: "Sázku nelze uzavřít z důvodu vyloučení z hraní, které jste si nastavili.",
    RECONCILE: "Váš účet nesplňuje kompletní podmínky ověření účtu pro kurzové sázky nebo limity zodpovědného hraní.",
    UNKNOWN_ERROR: "Došlo k chybě, překontrolujte svou sázku.",
};

export interface TicketLeg {
    documentId: string;
    options: Options;
    outcomes: Outcome[];
}

export interface Options {
    banker: boolean;
    winPlace: string;
    combinationRef?: string;
    group?: string;
    prices: Price[];
}

export interface Price {
    priceTypeRef: string;
    numerator: number;
    denominator: number;
    decimal: string;
    handicapHigh?: string;
    handicapLow?: string;
    american: string;
}

export interface Outcome {
    outcomeRef: string;
    eachWayTerms: EachWayTerms;
    outcomeDetails: OutcomeDetails;
    banker: boolean;
    tags: Tags[];
    inRunning: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    result?: any; //according to the specification it should exist but it is not present in the response at the moment
}

export interface Tags {
    name: string;
    value: string;
}

export interface EachWayTerms {}

export interface OutcomeDetails {
    id: string;
    prices: Price[];
    adjustments: Adjustment[];
    name: string;
    marketRef: string;
    marketName: string;
    eventRef: string;
    eventName: string;
    typeRef: string;
    typeName: string;
    classRef: string;
    className: string;
    categoryRef: string;
    categoryName: string;
    startDate: Date;
    result: string;
}

export interface Adjustment {
    type: string;
    displayValue: string;
}
